"use client";

import { NoteFeature, Tire } from "@/@types";
import UsedProductNoteFeaturesTable from "./UsedProductNoteFeaturesTable";

type Props = {
    tires?: Tire[],
    noteFeatures?: NoteFeature[],
}

export default function UsedProductTireContent({ tires, noteFeatures }: Props) {
    if (!tires || tires.length === 0 ) {
        return <p className="font-bold">Sin información</p>;
    }

    return (
        <div>
            {noteFeatures && noteFeatures.length > 0 && (
                <UsedProductNoteFeaturesTable 
                    noteFeatures={noteFeatures}
                />
            )}
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm border border-gray-300">
                    <thead className="bg-gray-100 text-left">
                        <tr>
                            <th className="p-2 border">CONCEPTO</th>
                            <th className="p-2 border">FABRICANTE</th>
                            <th className="p-2 border">PROFUNDIDAD</th>
                            <th className="p-2 border">% VIDA RESTANTE</th>
                            <th className="p-2 border">RESUMEN</th>
                            <th className="p-2 border">CORTES EN RODAMIENTO</th>
                            <th className="p-2 border">CORTES LATERALES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tires.map((tire, index) =>
                            tire.tireFeatures.map((feature, idx) => (
                            <tr key={`${index}-${idx}`} className="border-t">
                                <td className="p-2 border uppercase">{feature.concept ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.manufacturer ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.treadDepth ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.remainingLifePercentage ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.summary ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.treadCutChunks ?? "-"}</td>
                                <td className="p-2 border uppercase">{feature.sideCuts ?? "-"}</td>
                            </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}